import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreStatusForm from '../../../components/forms/ScoreStatusForm';
import { useScoreStatusById, useUpdateScoreStatus } from '../../../hooks/useScoreStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ScoreStatusDTO } from '../../../services/apiClient';

const ScoreStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useScoreStatusById(id);
  const updateMutation = useUpdateScoreStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Score Statuses', href: '/admin/scorestatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/scorestatuses');
    } catch (error) {
      console.error('Error updating ScoreStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scorestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ScoreStatus.Edit"
    >
        {entityData ? (
          <ScoreStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/scorestatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ScoreStatusEdit;
